export default __webpack_public_path__ + "static/media/capture-feedback-template.007d74d3.pptx";